import { render, staticRenderFns } from "./decline-reason-block.vue?vue&type=template&id=43f0645a"
import script from "./decline-reason-block.vue?vue&type=script&lang=js"
export * from "./decline-reason-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports